/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypemathgraphfillinblank6Inputs */

const zh_learn_mistakestypemathgraphfillinblank6 = /** @type {(inputs: Learn_Mistakestypemathgraphfillinblank6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数学图表填空`)
};

const en_learn_mistakestypemathgraphfillinblank6 = /** @type {(inputs: Learn_Mistakestypemathgraphfillinblank6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Math Graph Fill in Blank`)
};

const es_learn_mistakestypemathgraphfillinblank6 = /** @type {(inputs: Learn_Mistakestypemathgraphfillinblank6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráfico matemático para completar`)
};

/**
* | output |
* | --- |
* | "Math Graph Fill in Blank" |
*
* @param {Learn_Mistakestypemathgraphfillinblank6Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypemathgraphfillinblank6 = /** @type {((inputs?: Learn_Mistakestypemathgraphfillinblank6Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypemathgraphfillinblank6Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypemathgraphfillinblank6(inputs)
	if (locale === "en") return en_learn_mistakestypemathgraphfillinblank6(inputs)
	return es_learn_mistakestypemathgraphfillinblank6(inputs)
});
export { learn_mistakestypemathgraphfillinblank6 as "learn_mistakesTypeMathGraphFillInBlank" }